export const fr = {
    translation: {
        common: {
            trial: "Version d'essai",
            expired: "Expiré",
            renewal: "Renouvellement",
            quantity: "Qté",
            error: "Erreur",
            all: "Tout",
            loading: "Chargement...",
            thank_you: "Merci",
            confirm: "Confirmer",
            cancel: "Annuler",
            save: "Enregistrer",
            add: "Ajouter",
            edit: "Modifier",
            delete: "Supprimer",
            warning: "Attention",
            delete_confirm_text: "Cette action est irréversible. Êtes-vous sûr de vouloir supprimer ?",
            click_to_select: "Sélectionner...",
            unit: "Unité",
            detail: "Détail",
            done: "Terminé",
            search: "Rechercher",
            processing: "Traitement...",
            success: "Succès",
            total: "Total",
            none: "Aucun"
        },
        roles: {
            admin: "Admin",
            barista: "Barista",
            waiter: "Serveur",
            kitchen: "Cuisine"
        },
        auth: {
            user_not_found: "Utilisateur non trouvé !",
            welcome: "Bon retour",
            subtitle: "Connectez-vous pour gérer votre café",
            google_login: "Se connecter avec Google",
            apple_login: "Se connecter avec Apple",
            secure_login: "Connexion sécurisée",
            terms_text: "En vous connectant, vous acceptez nos conditions d'utilisation et notre politique de confidentialité."
        },
        sidebar: {
            dashboard: "Tableau de bord",
            tables: "Tables",
            staff: "Personnel",
            loyalty: "CRM & Fidélité",
            qr_menu: "Menu QR",
            menu_product: "Menu & Produits",
            stock_recipe: "Stock & Recettes",
            reports: "Rapports",
            settings: "Paramètres",
            admin_panel: "Panneau Admin",
            not_logged_in: "Non connecté",
            click_to_select: "Choisir un profil",
            switch_profile: "Changer de profil",
            logout: "Déconnexion"
        },
        dashboard: {
            overview: "Aperçu du tableau de bord",
            today: "Aujourd'hui",
            system_active: "Système actif",
            offline: "Mode hors ligne",
            payment_reminder: "Rappel de paiement",
            payment_missing_list: "Le paiement pour {{names}} n'a pas encore été effectué.",
            add_expense: "Ajouter une dépense",
            daily_revenue: "Revenu journalier",
            open_tables: "Tables ouvertes",
            pending_tables: "Commandes en attente",
            waiting_approval: "En attente d'approbation",
            active_staff: "Personnel actif",
            hourly_revenue: "Revenu horaire",
            hourly_profit: "Profit horaire",
            work_hours: "Heures de travail",
            hours_24: "24 Heures",
            revenue: "Revenu",
            profit: "Profit",
            best_sellers: "Meilleures ventes",
            support_modal: { other: "Autre" },
            weekly_performance: "Performance hebdomadaire",
            weekly_revenue: "Revenu hebdomadaire",
            increase: "Augmentation",
            decrease: "Diminution",
            busiest_day: "Jour le plus chargé",
            view_report: "Voir le rapport",
            critical_stock_warning: "Stock critique",
            quick_actions: "Actions rapides",
            x_report: "Rapport X",
            sync: "Sync",
            backup: "Sauvegarde",
            support: "Support",
            help_support: "Aide & Support",
            help_desc: "Comment pouvons-nous vous aider ?",
            report_issue: "Signaler un problème",
            version: "Version",
            topic: "Sujet",
            technical: "Problème technique",
            suggestion: "Suggestion",
            other: "Autre",
            description: "Description",
            desc_placeholder: "Veuillez décrire le problème...",
            send_report: "Envoyer le rapport"
        },
        tables: {
            status: {
                occupied: "Occupé",
                paid: "Payé",
                reserved: "Réservé",
                empty: "Vide"
            },
            alerts: {
                reservation_time: "Heure de réservation :",
                draft_paid: "Brouillon payé",
                draft_unpaid: "Brouillon de commande"
            },
            title: "Plan de salle",
            tabs: {
                plan: "Plan",
                history: "Historique"
            },
            filter: {
                all: "Tout"
            },
            actions: {
                finish_edit: "Terminer l'édition",
                edit: "Modifier les tables",
                add_table: "Ajouter une table",
                quick_pay: "Paiement rapide",
                reserve: "Réserver",
                clear: "Vider"
            },
            card: {
                capacity: "Pers.",
                just_now: "À l'instant",
                total: "Total",
                has_request: "Nouvelle demande",
                no_order: "Pas de commande"
            },
            history: {
                search_placeholder: "Chercher N° Ticket ou Table...",
                multi_pay: "Paiement multiple"
            },
            sections: {
                manage: "Gérer les sections",
                add_placeholder: "Nom de la nouvelle section",
                no_sections: "Aucune section définie."
            },
            modal: {
                edit_title: "Modifier la table",
                add_title: "Ajouter une table",
                name: "Nom de la table",
                name_placeholder: "ex. Table 5",
                section: "Section",
                capacity: "Capacité",
                delete: "Supprimer la table",
                unpaid_warning_title: "Solde impayé !",
                clear_confirm_title: "Vider la table ?",
                unpaid_warning_text: "<b>{{name}}</b> a un solde impayé. La vider réinitialisera la commande.",
                clear_confirm_text: "Êtes-vous sûr de vouloir vider <b>{{name}}</b> ?",
                delete_confirm_text: "Êtes-vous sûr de vouloir supprimer <b>{{name}}</b> ?"
            },
            qr_review: {
                title: "Commande QR entrante",
                subtitle: "Nouvelle demande de {{name}}",
                current_state: "État actuel de la table",
                table_empty: "La table est actuellement vide.",
                current_total: "Total actuel",
                incoming_request: "Demande entrante",
                extra_total: "Total supplémentaire",
                reject: "Rejeter",
                overwrite: "Écraser",
                overwrite_desc: "Effacer l'actuel & définir le nouveau",
                merge: "Fusionner",
                merge_desc: "Ajouter à l'existant"
            }
        },
        orders: {
            status: {
                completed: "Terminé"
            },
            list: {
                ticket_no: "N° Ticket",
                date: "Date/Heure",
                table: "Table/Client",
                method: "Méthode",
                amount: "Montant",
                status: "Statut"
            },
            modal: {
                match_error: "Le total du paiement ({{pay}}€) ne correspond pas au total de la commande ({{total}}€).",
                title: "Détails de la transaction",
                content_title: "Contenu de la commande",
                total_title: "Montant total",
                payment_details: "Détails du paiement",
                entered_total: "Total saisi",
                difference: "Différence"
            },
            correction: {
                note_placeholder: "ex. Erreur de saisie par le personnel"
            },
            void_flow: {
                button_update: "Mettre à jour le statut / Annuler",
                button_void: "Annuler / Rembourser",
                title_select: "Sélectionner le type d'annulation",
                type_cancel: "Erreur / Retour",
                type_cancel_desc: "Rétablit le stock",
                type_wastage: "Gaspillage / Renversé",
                type_wastage_desc: "Déduit du stock (Pas de retour)",
                confirm_cancel_title: "Marquer comme Erreur/Retour",
                confirm_wastage_title: "Marquer comme Gaspillage",
                confirm_cancel_text: "Ceci annulera la vente et rétablira tout le stock dans l'inventaire. Êtes-vous sûr ?",
                confirm_wastage_text: "Ceci annulera la vente mais le stock sera considéré comme UTILISÉ/PERDU. Êtes-vous sûr ?",
                confirm: "CONFIRMER"
            }
        },
        pos: {
            title_quick: "Commande rapide",
            title_no_table: "Pas de table",
            title_table: "{{name}}",
            search_placeholder: "Rechercher produit...",
            grid: {
                sold_out: "ÉPUISÉ"
            },
            ticket: {
                title: "Ticket actuel",
                order_no: "N° COMMANDE",
                new: "NOUVEAU",
                empty: "Le panier est vide.",
                status: {
                    wastage: "GASPILLAGE",
                    comp: "OFFERT",
                    cancelled: "ANNULÉ",
                    paid: "PAYÉ"
                },
                discount_badge: "REMISE"
            },
            actions: {
                discount: "REMISE",
                comp: "OFFERT",
                void: "GASPILLAGE",
                cancel: "ANNULER",
                pay: "PAYER",
                assign_table: "TABLE",
                save: "SAUVER",
                waiting_payment: "ATTENTE PAIEMENT",
                close_ticket: "FERMER TICKET"
            },
            totals: {
                subtotal_net: "Sous-total (HT)",
                tax_vat: "Taxe (TVA)",
                grand_total: "Grand Total",
                tax_exclusive_hint: "(+Taxe)"
            },
            alerts: {
                table_not_found: "Table non trouvée.",
                perm_comp: "Vous n'avez pas la permission d'offrir des articles.",
                perm_void: "Vous n'avez pas la permission d'annuler des articles.",
                select_item_error: "Veuillez sélectionner un article.",
                paid_item_error: "Les articles payés ne peuvent pas être modifiés.",
                split_quantity: "Combien d'articles sur {{count}} voulez-vous déplacer ?",
                invalid_amount: "Montant invalide.",
                perm_discount: "Vous n'avez pas la permission d'appliquer des remises.",
                select_discount_item: "Sélectionnez un article pour la remise.",
                paid_discount_error: "Impossible de faire une remise sur des articles payés.",
                add_items_first: "Veuillez d'abord ajouter des articles au panier.",
                unauthorized: "Accès refusé"
            },
            modifier_modal: {
                no_modifiers: "Aucun modificateur disponible.",
                multiple: "multiple",
                add_to_cart: "Ajouter au panier"
            },
            discount_modal: {
                title: "Appliquer une remise",
                percent: "Pourcentage",
                amount: "Montant",
                comp_100: "OFFERT (100%)",
                old_total: "Ancien Total",
                new_total: "Nouveau Total",
                apply: "Appliquer la remise"
            }
        },
        payment: {
            alerts: {
                enter_valid: "Veuillez entrer un montant valide.",
                balance_not_zero: "Le solde restant doit être de 0 pour fermer le ticket."
            },
            header_order: "Commande",
            header_open: "Ticket ouvert",
            ticket_details: "Détails du ticket",
            select_all: "Tout sélectionner",
            items_count: "{{count}} Articles",
            empty_list: "Aucun article",
            remaining_badge: "Reste : {{amount}}",
            recent_transactions: "TRANSACTIONS RÉCENTES",
            totals: {
                total: "Total",
                paid: "Payé",
                remaining: "Restant"
            },
            amount_to_collect: "Montant à encaisser",
            give_change: "Monnaie",
            return_to_customer: "Rendre au client",
            methods: {
                cash: "Espèces",
                card: "Carte bancaire",
                qr: "QR / Mobile",
                other: "Ticket resto"
            },
            numpad: {
                all: "Tout"
            },
            actions: {
                cancel: "Annuler",
                close_ticket: "Fermer le ticket",
                waiting_payment: "En attente de paiement"
            }
        },
        menu: {
            title: "Gestion du menu",
            subtitle: "Gérer les produits, prix et stocks",
            add_new: "Ajouter un produit",
            edit_title: "Modifier le produit",
            add_title: "Ajouter un produit",
            manage_categories: "Gérer les catégories",
            alerts: {
                no_permission: "Vous n'avez pas la permission de gérer le menu.",
                delete_confirm: "Êtes-vous sûr de vouloir supprimer ce produit ?"
            },
            form: {
                image_select: "Sélectionner une image",
                image_change: "Changer l'image",
                image_recommendation: "Format carré recommandé",
                image_max_size: "Max 2Mo",
                name: "Nom du produit",
                name_placeholder: "ex. Latte",
                category: "Catégorie",
                price: "Prix",
                stock_tracking: "Suivi de stock",
                stock_hint: "Laisser 0 pour désactiver",
                description: "Description",
                description_placeholder: "Ingrédients, détails...",
                customizable: "Personnalisable (Modificateurs)"
            },
            categories: {
                title: "Gestion des catégories",
                add: "Ajouter une catégorie",
                name: "Nom de la catégorie",
                edit: "Modifier la catégorie",
                delete_confirm: "Supprimer cette catégorie ?"
            }
        },
        categories: {
            all: "Tout",
            hot_coffees: "Cafés chauds",
            cold_coffees: "Cafés froids",
            desserts: "Desserts",
            snacks: "Snacks",
            barista_special: "Spécial"
        },
        stock: {
            title: "Gestion des stocks",
            subtitle: "Stock, Recettes et Modificateurs",
            tabs: {
                inventory: "Inventaire",
                recipes: "Recettes",
                modifiers: "Modificateurs"
            },
            inventory: {
                total_value: "Valeur totale",
                sku_count: "Nombre SKU",
                alerts: "Alertes stock",
                search_placeholder: "Rechercher stock...",
                add_stock: "Ajouter article",
                status_critical: "Critique",
                status_warning: "Bas",
                status_sufficient: "OK",
                table: {
                    name: "Nom",
                    supplier: "Fournisseur",
                    amount: "Quantité",
                    status: "Statut",
                    unit_cost: "Coût unitaire",
                    actions: "Actions"
                },
                modal: {
                    edit_title: "Modifier stock",
                    add_title: "Ajouter stock",
                    general_info: "Info générale",
                    management: "Gestion",
                    name: "Nom de l'article",
                    name_placeholder: "ex. Lait",
                    supplier: "Fournisseur",
                    supplier_placeholder: "ex. Ferme locale",
                    unit: "Unité",
                    alarm_thresholds: "Seuils d'alarme",
                    warning_limit: "Limite d'avertissement",
                    critical_limit: "Limite critique",
                    stock_status: "Statut du stock",
                    finish_editing: "Terminer l'édition",
                    manual_correction: "Correction manuelle",
                    current_amount: "Quantité actuelle",
                    unit_cost: "Coût unitaire",
                    new_purchase: "Nouvel achat / Entrée",
                    add_amount: "Ajouter quantité",
                    purchase_price: "Prix d'achat",
                    total: "Total",
                    unit_price: "Prix unitaire",
                    success_feedback: "Mis à jour !",
                    calculate_add: "Calculer & Ajouter",
                    avg_cost_note: "* Calcule le coût moyen pondéré."
                }
            },
            wastage: {
                title: "Signaler gaspillage",
                subtitle: "Signalement de perte pour {{name}}",
                amount: "Quantité",
                reason: "Raison",
                reason_placeholder: "ex. Renversé, Gâté",
                report: "Signaler"
            },
            recipes: {
                search_product: "Rechercher produit...",
                gross_margin: "Marge brute",
                sale_price: "Prix de vente",
                cost_price: "Prix de revient",
                ingredients: "Ingrédients",
                no_recipe: "Aucune recette définie.",
                add_ingredient: "Ajouter ingrédient",
                stock_item: "Article de stock",
                amount: "Quantité",
                unit: "Unité"
            },
            modifiers: {
                title: "Groupes de modificateurs",
                new_group: "Nouveau groupe",
                group_name: "Nom du groupe",
                selection_type: "Type de sélection",
                single: "Unique (Radio)",
                multiple: "Multiple (Case à cocher)",
                options: "Options",
                option_name: "Nom de l'option",
                option_placeholder: "ex. Lait d'avoine",
                extra_price: "Prix supplémentaire",
                deduct_stock: "Déduire du stock (Optionnel)",
                add_option: "Ajouter une option",
                group_helper_text: "Gérez les options pour ce groupe ci-dessous.",
                no_link: "Pas de lien",
                stock_optional_label: "Stock (Optionnel)",
                edit_group_title: "Modifier le groupe",
                allow_multiple_label: "Autoriser sélections multiples",
                delete_group_confirm: "Êtes-vous sûr de vouloir supprimer ce groupe ?"
            }
        },
        reports: {
            title: "Aperçu financier",
            filters: { today: "Aujourd'hui", week: "Semaine", month: "Mois", all: "Tout" },
            kpi: {
                revenue: "Revenu total",
                net_revenue: "Revenu net (HT)",
                tax_collected: "Taxes collectées",
                income: "Entrées",
                expense: "Dépenses totales",
                expense_opr: "Opérationnel",
                expense_stock: "COGS",
                expense_wastage: "Gaspillage",
                profit: "Profit net",
                profit_opr: "Profit opérationnel",
                cash_in_hand: "Flux de trésorerie",
                gross_profit: "Marge brute",
                tickets: "Total tickets",
                sales_count: "Nombre de ventes",
                expense_analysis: "Analyse des dépenses",
                profit_analysis: "Analyse du profit net",
                available_in_standard: "Disponible dans le plan Standard",
                locked: "Verrouillé"
            },
            toggles: {
                stock_cost: "Coût stock",
                wastage: "Gaspillage",
                operational: "Mode opérationnel",
                net_revenue: "Revenu net (Taxe)"
            },
            charts: {
                sales_title: "Graphique des ventes ({{currency}})",
                hourly: "Horaire",
                daily: "Journalier",
                monthly: "Mensuel",
                distribution: "Distribution",
                category_breakdown: "Répartition par catégorie",
                revenue_share: "Part de revenu",
                no_data: "Pas de données.",
                tooltip_revenue: "Revenu : ",
                tooltip_net_revenue: "Revenu net : ",
                tooltip_profit: "Profit : "
            },
            transactions: {
                title: "Historique des transactions",
                count_listed: "{{count}} Enregistrements listés",
                table: {
                    ticket_no: "N° Ticket",
                    date: "Date / Heure",
                    table: "Table",
                    method: "Méthode",
                    amount: "Montant",
                    status: "Statut"
                },
                status: {
                    completed: "Terminé",
                    cancelled: "Annulé"
                },
                no_records: "Aucune transaction trouvée dans la plage sélectionnée."
            },
            x_report: {
                title: "Rapport de caisse instantané (Rapport X)",
                total_cash: "Total espèces en caisse",
                daily_tickets: "Tickets du jour",
                cancelled_trx: "Transactions annulées",
                collections: "Encaissements (Actuel)",
                shift_reports: "Rapports de service (Aujourd'hui)",
                no_shift: "Pas encore de rapport de service.",
                total_sales: "VENTES TOTALES",
                cash: "Espèces",
                credit_card: "Carte bancaire",
                qr_mobile: "QR / Mobile",
                meal_card: "Ticket resto"
            },
            z_report: {
                title: "Rapport de fin de journée (Rapport Z)",
                auto_toggle: "Rapport Z Auto",
                auto_desc: "À 00:00",
                close_button: "CLÔTURER LA JOURNÉE (RAPPORT Z)",
                history_title: "Rapports Z passés",
                no_reports: "Pas encore de rapport.",
                receipt: {
                    title: "RAPPORT Z",
                    report_no: "N° Rapport",
                    cashier: "Caissier",
                    total_sales: "VENTES TOTALES",
                    tax_base: "Base imposable",
                    total_tax: "Total taxes",
                    payment_details: "Détails paiement",
                    cash: "Espèces",
                    card: "Carte bancaire",
                    other: "Autre",
                    end: "--- FIN ---"
                }
            },
            modals: {
                close_confirm: {
                    title: "Clôturer la journée ?",
                    text: "Cette action archivera <strong>{{count}}</strong> transactions ouvertes et générera un Rapport Z officiel. Irréversible.",
                    cancel: "Annuler",
                    confirm: "Confirmer & Clôturer"
                },
                expense: {
                    title: "Ajout dépense rapide",
                    date: "Date",
                    category: "Catégorie",
                    amount: "Montant",
                    description: "Description",
                    optional: "Optionnel...",
                    set_default: "Définir par défaut",
                    last_trx: "Dernier : {{amount}} ({{date}})"
                },
                processing: {
                    title: "Génération du Rapport Z...",
                    text: "Veuillez patienter, traitement de fin de journée..."
                }
            },
            liabilities: {
                pending: "Paiements en attente",
                label_today: "Part de dépense (Auj.)",
                label_week: "Part de dépense (Sem.)",
                label_total: "Paiements récurrents en attente"
            }
        },
        settings: {
            general: "Paramètres généraux",
            titles: {
                general: "Général",
                expenses: "Dépenses",
                modifiers: "Modificateurs",
                developer: "Développeur"
            },
            descriptions: {
                general: "Paramètres système, langue et entreprise",
                expenses: "Configuration financière",
                developer: "Outils de simulation et test"
            },
            subscription: {
                active: "ACTIF",
                inactive: "INACTIF",
                expired: "EXPIRÉ",
                renew: "Renouveler",
                days_left: "Jours restants",
                next_payment: "Prochain paiement",
                period_start: "Début de période",
                time_remaining: "Temps restant",
                lite_plan: "Plan Lite",
                standard_plan: "Plan Standard"
            },
            business_identity: "Identité de l'entreprise",
            financial: "Paramètres financiers",
            financial_desc: {
                currency_desc: "Symbole utilisé dans tout le système",
                pricing_desc: "Méthode de calcul des taxes"
            },
            interface: {
                title: "Interface",
                scale: "Échelle UI (Zoom)",
                scale_desc: "Ajustez l'échelle pour les éléments trop petits/grands.",
                note: "Note :",
                scale_note: "L'échelle auto est toujours active sur les écrans < 1366px."
            },
            operational: {
                title: "Heures de travail & Services",
                start_hour: "Heure de début (0-23)",
                end_hour: "Heure de fin (0-23)",
                info_text: "Ce paramètre détermine la plage horaire affichée sur le graphique des ventes horaires.",
                updated_alert: "Heures de travail mises à jour."
            },
            shortcuts: {
                staff_desc: "Gérer Serveurs, Baristas et Admins"
            },
            backup: {
                title: "Données & Sauvegarde",
                backup_now: "Sauvegarder",
                backup_desc: "Télécharger la base de données (.json)",
                restore: "Restaurer",
                restore_desc: "Sélectionner fichier .json",
                factory_reset: "Réinitialisation usine",
                reset_desc: "Toutes les données seront effacées.",
                reset_button: "Réinitialiser les données",
                success_restore: "Sauvegarde restaurée avec succès."
            },
            security: {
                reset_title: "Réinitialisation usine",
                restore_title: "Restaurer depuis sauvegarde",
                reset_text: "Cette action est irréversible. Toutes les données seront supprimées.",
                restore_text: "Les données actuelles seront supprimées et remplacées par la sauvegarde.",
                admin_required: "Approbation Admin requise",
                enter_pin: "Veuillez entrer le PIN",
                confirm_reset: "Supprimer & Réinitialiser",
                confirm_restore: "Lancer la restauration"
            },
            messages: {
                updated: "Paramètres mis à jour.",
                error: "Une erreur est survenue."
            },
            sync: {
                title: "Sync Cloud",
                pending: "{{count}} éléments en attente",
                up_to_date: "Toutes les données sont à jour",
                button: "Synchroniser"
            }
        },
        financials: {
            title: "Paramètres financiers",
            subtitle: "Taux de taxe et catégories de dépenses",
            tabs: {
                taxes: "Taxes",
                expenses: "Dépenses",
                history: "Historique"
            },
            taxes: {
                title: "Taux de taxe",
                active_rates: "Taux actifs",
                rate_name: "Nom du taux",
                rate_percent: "Taux %",
                description: "Description",
                add_new: "Ajouter un taux",
                category_mapping: "Mappage Taux/Catégorie"
            },
            expenses: {
                title: "Catégories de dépenses",
                add_new: "Ajouter catégorie",
                category_name: "Nom catégorie",
                description: "Description",
                default_amount: "Montant par défaut",
                recurring: "Récurrent (Mensuel)",
                recurring_day: "Jour du mois",
                distribute_daily: "Distribuer quotidiennement"
            },
            history: {
                title: "Historique dépenses",
                filter_all: "Toutes catégories",
                no_records: "Aucun enregistrement trouvé.",
                table: {
                    date: "Date",
                    category: "Catégorie",
                    description: "Description",
                    amount: "Montant"
                }
            }
        },
        crm: {
            title: "CRM & Fidélité",
            subtitle: "Gestion clients & Programme fidélité",
            give_points: "Donner des points",
            qr_instruction: "Scanner QR code pour client",
            generate_qr: "Générer QR",
            qr_description: "Montrez ce code QR au client pour ajouter des points.",
            customer_list: "Liste clients",
            search_placeholder: "Chercher client...",
            last_visit: "Dernière visite :",
            eligible: "Récompense disponible !",
            settings_title: "Paramètres campagne",
            target_points: "Points cibles",
            reward_name: "Nom récompense",
            preview: "Aperçu carte",
            target_label: "Cible",
            coming_soon: "Bientôt"
        },
        qr: {
            title: "Menu QR",
            subtitle: "Menu numérique & Système de commande",
            simulate: "Simuler commande",
            print_selected: "Imprimer sélection",
            lock: {
                title: "Services en ligne verrouillés",
                desc: "Le Menu QR et les commandes en ligne sont disponibles dans le plan Standard.",
                upgrade_btn: "Mettre à niveau"
            },
            print: {
                title: "Imprimer QR Codes",
                scan_instruction: "Scanner pour voir le menu"
            },
            preview: {
                title: "Aperçu en direct",
                network: "Réseau :",
                password: "Mdp :",
                powered_by: "Propulsé par KahveInn",
                disclaimer: "* Ceci est un aperçu de l'apparence du stand QR.",
                scan_instruction: "Scanner pour le menu"
            },
            settings: {
                general: "Général",
                active: "Actif",
                active_desc: "Activer le système Menu QR",
                ordering: "Autoriser commandes",
                ordering_desc: "Les clients peuvent commander",
                sound: "Alerte sonore",
                sound_desc: "Jouer un son à la nouvelle commande",
                design: "Design",
                header_text: "Texte d'en-tête",
                theme_color: "Couleur du thème",
                wifi_ssid: "SSID Wi-Fi",
                wifi_pass: "Mot de passe Wi-Fi"
            },
            selection: {
                title: "Sélection de table",
                select_all: "Tout sélectionner",
                previewing: "Prévisualisation"
            },
            modal: {
                permission_title: "Permission requise",
                permission_text: "Nous avons besoin de la permission pour jouer les notifications sonores.",
                allow_btn: "Autoriser le son"
            }
        },
        staff: {
            title: "Gestion du personnel",
            subtitle: "Employés et autorisation",
            tabs: {
                list: "Liste personnel",
                roles: "Rôles & Permissions"
            },
            lite_banner: {
                title: "Plan Lite",
                desc: "La gestion avancée du personnel est restreinte."
            },
            stats: {
                total: "Total personnel",
                on_duty: "En service"
            },
            matrix: {
                person: "Personne"
            },
            auto_shift_report: "Rapport de service auto",
            modal: {
                add_title: "Ajouter personnel",
                edit_title: "Modifier personnel",
                delete: "Supprimer personnel",
                name: "Nom complet",
                role: "Rôle",
                pin: "Code PIN (4 chiffres)",
                phone: "Téléphone (Optionnel)",
                status: "Statut",
                status_working: "Travaille",
                status_off: "En repos"
            },
            roles_tab: {
                title: "Rôles",
                subtitle: "Personnaliser les permissions",
                permissions: "Permissions",
                no_permissions: "Aucune permission assignée"
            },
            contact: "Contact",
            status: {
                working: "Travaille",
                offline: "En repos"
            },
            permission_matrix: "Matrice de permission",
            no_pin_permission: "Pas de permission pour voir/changer le PIN",
            unauthorized_tooltip: "Vous ne pouvez pas modifier cet utilisateur",
            alerts: {
                no_add_permission: "Vous n'avez pas la permission d'ajouter du personnel.",
                no_edit_others: "Vous ne pouvez modifier que votre propre profil.",
                no_edit_admin: "Seuls les Admins peuvent modifier les Admins.",
                no_delete_self: "Vous ne pouvez pas vous supprimer vous-même.",
                no_delete_permission: "Vous n'avez pas la permission de supprimer du personnel.",
                no_delete_admin: "Seuls les Admins peuvent supprimer les Admins.",
                delete_confirm: "Êtes-vous sûr de vouloir supprimer ce membre du personnel ?",
                no_status_admin: "Seuls les Admins peuvent changer le statut Admin.",
                only_admin_roles: "Seuls les Admins peuvent changer les permissions des rôles."
            }
        },
        permission_groups: {
            general: "Général",
            sales: "Ventes",
            management: "Gestion"
        },
        permissions: {
            VIEW_FINANCIALS: { label: "Voir les finances", description: "Accès aux revenus et profits" },
            VIEW_TABLES: { label: "Voir les tables", description: "Voir le plan de salle et commandes" },
            MANAGE_MENU: { label: "Gérer le menu", description: "Ajouter et modifier des produits" },
            MANAGE_STOCK: { label: "Gérer le stock", description: "Contrôle de l'inventaire" },
            VIEW_REPORTS: { label: "Voir les rapports", description: "Accès aux pages de rapports" },
            MANAGE_STAFF: { label: "Gérer le personnel", description: "Ajouter/supprimer du personnel" },
            MANAGE_SETTINGS: { label: "Gérer les paramètres", description: "Configuration du système" },
            VOID_ITEM: { label: "Annuler article", description: "Opérations d'annulation ou gaspillage" },
            OFFER_COMP: { label: "Offrir", description: "Permission de donner des articles gratuits" },
            APPLY_DISCOUNT: { label: "Appliquer remise", description: "Appliquer une remise à la commande" },
            CLOSE_DAY: { label: "Clôturer la journée", description: "Permission de faire le Rapport Z" }
        },
        setup: {
            business_name: "Nom de l'entreprise",
            business_address: "Adresse",
            manager_name: "Nom du gérant",
            manager_hint: "Votre nom pour le profil gérant",
            staff_count: "Nombre d'employés",
            staff_hint: "Nombre estimé d'employés",
            currency: "Devise",
            pricing_model: "Modèle de tarification",
            tax_inclusive: "TTC (Taxe incluse)",
            tax_exclusive: "HT (+ Taxe)",
            completing: "Finalisation...",
            title_1: "Bienvenue",
            title_2: "Équipe & Gestion",
            title_3: "Paramètres financiers",
            desc_1: "Créons votre identité d'entreprise.",
            desc_2: "Configurons votre structure d'équipe.",
            desc_3: "Sélectionnez votre devise et vos préférences fiscales.",
            skip_dev: "Passer (Dev)",
            back: "Retour",
            next: "Suivant",
            finish: "Terminer",
            placeholders: {
                business_name: "ex. KahveInn",
                city: "Ville (ex. Paris)",
                district: "Quartier (ex. Le Marais)",
                address_detail: "Rue, N° Bâtiment...",
                manager_name: "Votre nom complet"
            },
            errors: {
                business_name: "Veuillez entrer le nom de l'entreprise.",
                city: "Veuillez entrer la ville.",
                district: "Veuillez entrer le quartier.",
                address_detail: "Veuillez entrer l'adresse complète.",
                manager_name: "Veuillez entrer le nom du gérant.",
                staff_count: "Veuillez entrer un nombre valide."
            },
            currencies: {
                try: "Lira Turque (₺)",
                usd: "$ - Dollar US ($)",
                eur: "Euro (€)",
                gbp: "Livre Sterling (£)"
            },
            loading_text: "Votre système est en cours de préparation, veuillez patienter."
        }
    }
};
